import { useQueryClient, useMutation } from "react-query";

export default function useOptimisticUpdate(key, fn){

    const queryClient = useQueryClient();

    return useMutation(fn ? fn : () => false, {

        onMutate: async data => {

            await queryClient.cancelQueries({ queryKey: [key] })

            const previous = queryClient.getQueryData([key])

            queryClient.setQueryData([key], old => {

                let copy = [...old];
                copy = copy.filter(i => i.id !== data.id)
                copy.push(data)

                return copy;
            })

            return { previous }
        },

        onError: (e, data, context) => {
            console.log(e, data)
            queryClient.setQueryData([key], context.previous)
        },

        onSettled: () => {
            queryClient.invalidateQueries({ queryKey: [key] })
        },
    })


}
